module.exports = __webpack_public_path__ + "img/download.2fff797c.svg";